import { Card, Tab, Tabs } from "@mui/material";
import GridTable from "cvmgmt-cube-grid-table";
import React, { useState } from "react";
import { getEnv } from "../../../Constants/env";
import { useNavigate } from "react-router-dom";
import { triggerToast } from "../../../utils/toast";
import AuditHistory from "../../../Components/UserManagment/AuditHistory/AuditHistory";
import { useSelector } from "react-redux";
import Typography from "../../../Components/Common/CprimeText";
import { useAuthSession } from "../../../hooks/useAuthSession";

const UserAccess: React.FC = () => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState<number>(0);
  const authSession = useAuthSession();
  const idToken = authSession?.idToken ?? null;
  const roles: string[] =
    authSession?.account?.idTokenClaims?.roles ??
    authSession?.idTokenClaims?.roles ??
    [];
  const isSuperAdmin = roles.some((role: string) => role.includes("RoleAdmin"));
  const { env } = useSelector((state: any) => state?.createApplication);

  return (
    <div style={{ padding: "2rem 2rem 0.5rem 2rem" }}>
      <Card
        variant="outlined"
        style={{
          borderRadius: "4px",
          marginBottom: "16px",
          border: "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          fontStyle={"normal"}
          fontFamily={"Toyota Type"}
          fontWeight={400}
          fontSize={"16px"}
          lineHeight={"22px"}
          style={{ padding: "16px" }}
        >
          User Access
        </Typography>
        {isSuperAdmin && (
          <Tabs
            value={tabValue}
            onChange={(event: React.SyntheticEvent, newValue: number) => {
              setTabValue(newValue);
            }}
            variant="standard"
            aria-label="Role Management"
            sx={{
              "& .MuiButtonBase-root": {
                color: "black !important",
                backgroundColor: "white",
              },
              "& .MuiTabs-indicator": {
                color: "black !important",
                backgroundColor: "black !important",
              },
              "& .MuiTabs-root": {
                marginBottom: "0px !important",
              },
            }}
          >
            <Tab
              label="User Activity"
              sx={{
                padding: "1rem 2rem",
                textTransform: "none",
                fontWeight: tabValue === 0 ? "bold" : "",
              }}
            />
            <Tab
              label="Audit History"
              sx={{
                padding: "1rem 2rem",
                textTransform: "none",
                fontWeight: tabValue === 1 ? "bold" : "",
              }}
            />
          </Tabs>
        )}
      </Card>
      {idToken !== null && tabValue === 0 && (
        <GridTable
          title="Users"
          style={{
            height: isSuperAdmin
              ? "calc(100vh - 30.5rem)"
              : "calc(100vh - 27.25rem)",
          }}
          customPayload={true}
          isCustomizeColumns={false}
          isPagination={true}
          apiConfig={{
            url: `${getEnv()?.baseURL}/user/userDetails?env=${env}`,
            data: {
              sortingFilter: {
                filter: [],
                sort: [],
                page: {
                  limit: 25,
                  offset: 0,
                },
              },
            },
            headers: {
              Authorization: idToken,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            documentUrl: "",
          }}
          onRowClick={(_, row: any) =>
            row?.original?.workday_id &&
            row?.original?.workday_id !== null &&
            row?.original?.workday_id?.length > 0
              ? navigate(`/user-access/${row?.original?.workday_id}`)
              : triggerToast(`Work Day Id is missing.`, "error")
          }
          showLoader={false}
        />
      )}
      {tabValue === 1 && <AuditHistory gridTitle="User Audit History" />}
    </div>
  );
};

export default UserAccess;
